// extracted by mini-css-extract-plugin
export default {"add-deviations-overlay":"_1Pft-","addDeviationsOverlay":"_1Pft-","content":"_11gFj"};